import { Link } from "react-router-dom";
import withLoader from "../../../components/layouts/WithLoader";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import PropTypes from "prop-types";
import Stepper from "@material-ui/core/Stepper";
import React, { useEffect, useState } from "react";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import ProductOrderService from "../../../services/ProductOrderService";
import ProductionOrderService from "../../../services/Production/ProductionOrderService";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return [
    "Inscrivez le bon de commande",
    "Choisir les produits et les quantités",
    "Finaliser",
  ];
}

const SendProductionOrder = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();

  const classes = useStyles();
  const steps = getSteps();
  const [activeStep, setActiveStep] = React.useState(0);
  const [transactions, setTransactions] = useState(null);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [productionOrderReference, setProductionOrderReference] = useState("");
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [allWarehouse, setAllWarehouse] = React.useState([{}]);
  const [warehouseId, setWarehouseId] = useState(0);
  const [productTableData, setProductTableData] = React.useState([]);
  const [showElement, setShowElement] = useState([]);
  const [disableTerminer, setDisableTerminer] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);
  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        // console.log("response", response);
        if (response.data.success) {
          setWarehouses(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  useEffect(() => {
    startLoading();
    warehouses &&
      warehouses.map((element) => {
        let exist = false;
        if (allWarehouse.length !== 0) {
          for (let index = 0; index < allWarehouse.length; index++) {
            if (allWarehouse[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouse((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
    stopLoading();
  }, [warehouses]);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleReset = () => {
    setActiveStep(0);
  };
  const onChangeProductionOrderReferenceHandler = (event) => {
    setProductionOrderReference(event.target.value);
  };
  const onChangeSelectedWarehouse = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };

  const columns = [
    {
      dataField: "productName",
      text: "Libellé",
      headerAlign: "center",
    },

    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
    },
  ];

  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <h5>
                  Obtenir les matières premières pour un ordre de production
                </h5>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Taper la réference de l'ordre de production </label>

                  <input
                    onChange={onChangeProductionOrderReferenceHandler}
                    value={productionOrderReference}
                    type="text"
                    required
                    id="productionOrder"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir le dépôt </label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedWarehouse}
                    options={allWarehouse}
                    placeholder={warehouseSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            {/* <div class="row">
                  <div className="col-sm-12">
                    <div class="form-group">
                      <label>Bon de livraison </label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            accept="application/pdf, .jpg, .jpeg, .png"
                            type="file"
                            className="custom-file-input"
                            id="exampleInputFile10"
                            onChange={onUploadFileHandler}
                          />
                          <label class="custom-file-label" for="exampleInputFile10">
                            Entrer le bon de livraison
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              
                <div class="row">
                  <div className="col-sm-6">
                    <div class="form-group">
                      <label>Choisir le produit</label>
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedProduct}
                        autosize={false}
                        options={products}
                        placeholder={productSelectPlaceHolder}
                      />
                    </div>
                  </div>
    
                  <div className="col-sm-6">
                    <div class="form-group">
                      <label>
                        Choisir la quantité ({currentQteProductPurchase})
                      </label>
    
                      <input
                        onChange={handlerChangeQt}
                        type="number"
                        min="0"
                        id="inputClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div class="form-group  clearfix">
                    <div class="icheck-asbestos d-inline">
                      <input
                        id="arrivage"
                        type="radio"
                        name="arrivage"
                        value="1"
                        checked={typeProduit === 1}
                        onChange={onValueChangeTypeProduit}
                      />
                      <label for="arrivage">Nouvel Arrivage </label>{" "}
                    </div>
    
                    <div class="icheck-asbestos d-inline">
                      <input
                        id="refuse"
                        type="radio"
                        value="2"
                        name="refuse"
                        checked={typeProduit === 2}
                        onChange={onValueChangeTypeProduit}
                      />
                      <label for="refuse">Refusé</label>
                    </div>
                    <div class="icheck-asbestos d-inline">
                      <input
                        id="accepte"
                        type="radio"
                        value="3"
                        name="accepte"
                        checked={typeProduit === 3}
                        onChange={onValueChangeTypeProduit}
                      />
                      <label for="accepte">Arrivage du retours</label>
                    </div>
                  </div>
                </div>
     */}
            {/* {typeProduitNote()} */}
            {/* <div class="row">
                  <div className="col-sm-12  text-center">
                    <button
                      style={{ marginBottom: 20 }}
                      className="btn btn-dark"
                      onClick={onAddProductToList}
                    >
                      <i class="fas fa-plus"></i>
                      Liste des achats{" "}
                    </button>
                  </div>
                </div> */}
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const handleNext = () => {
    if (activeStep === 0) {
      if (productionOrderReference === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : la réference est vide");
      } else if (
        (showElement.includes("PURCHASING_MANAGER") ||
          showElement.includes("ADMIN")) &&
        warehouseId === 0
      ) {
        if (warehouseId === 0) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : aucun dépot selectionné");
        }
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        startLoading();
        ProductionOrderService.getProductFromProductionOrder(
          productionOrderReference,
          getCurrentUserId(),
          warehouseId
        )
          .then((response) => {
            if (response.data.success) {
              setProductTableData(response.data.success);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            stopLoading();
          });
      }
    } else if (activeStep === 1) {
      if (productTableData.length === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :aucun produit à stocker");
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2) {
    

    startLoading();
    setDisableTerminer(true);
    ProductionOrderService.validateRawMateriel(
      productionOrderReference,
      getCurrentUserId(),
      warehouseId
    )
      .then((response) => {
        if (response.data.success) {
          console.log("response validateRawMateriel", response.data.success);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        stopLoading();
      });
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Les matieres premieres
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* <br /> */}
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div>
                    <div class="card-body">
                      <div class="row" style={{ marginTop: 0 }}>
                        {/* L'ajout au stock est terminé avec succée */}
                        {console.log("transaction", transactions)}
                        {/* {document && transactions && (
                              <DataTableTransactionEndRecieve
                                refFacture={document.ref}
                                listProduits={transactions}
                              />
                            )} */}
                      </div>
                    </div>
                    <div class="card-footer" style={{ marginTop: "1%" }}>
                      <button
                        className="btn btn-dark float-right"
                        onClick={handleReset}
                      >
                        Réinitialiser
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div class="card-body">{getStepContent(activeStep)}</div>

                    <div class="card-footer" style={{ marginTop: "1%" }}>
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-light"
                        onClick={handleBack}
                      >
                        Précédent
                      </button>

                      <button disabled={disableTerminer} className="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1
                          ? "Terminer"
                          : "Suivant"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(SendProductionOrder);
